import { DealerListContext } from 'app/components/ReactContexts/dealerListContext';
import { MenuAndContent, SubmenuAndContent } from 'app/components/layouts';
import { DealersNotLoaded } from 'app/pages/Equipment/DealersNotLoaded';
import React from 'react';
import { Outlet } from 'react-router-dom';

interface Props {
  submenu: JSX.Element;
}

export default function DealerMapGuard({ submenu }: Props) {
  const { dealerListData } = React.useContext(DealerListContext);

  const renderIfMapLoaded = (comp: JSX.Element) => {
    return dealerListData.isMapLoaded ? (
      comp
    ) : (
      <MenuAndContent>
        <DealersNotLoaded />
      </MenuAndContent>
    );
  };

  return renderIfMapLoaded(
    <SubmenuAndContent submenu={submenu}>
      <Outlet />
    </SubmenuAndContent>,
  );
}
